import CheckIcon from "../../phan-he-kham-benh/components/CheckIcon";
import { DATA_TYPE_XN } from "../const/constants";

export const convertListDichVuXetNgiem = (data: any[]) => {
	return data.map((item: any) => {
		return {
			name: item.parentName,
			subs: item?.orders.map((term: any) => ({
				...term,
				...term?.term,
				additionalConfiguration: term?.additionalConfiguration,
				name: !term?.isCanceled 
				? <CheckIcon
					data={term?.term}
					color={term?.statusColor}
				/> 
				: term?.term?.name,
				termOrderId: term?.id,
				subs: term?.term?.subs?.map((sub: any) => ({
					...sub,
					additionalConfiguration: term?.additionalConfiguration,
					orderId: term?.orderId,
					statusCode: term?.statusCode,
					statusColor: term?.statusColor,
					name: !term?.isCanceled 
					? <CheckIcon
						data={sub}
						color={term?.statusColor}
						className="ml-16"
					/> 
					: sub?.name,
				})),
			})),
		};
	});
};

export const genderClassName = (rowData: any) => {
	const validNumber = (value: any) => typeof value === "number" && !isNaN(value) && isFinite(value);
	const isText = rowData?.datatypeId === DATA_TYPE_XN.TEXT;
	const lowNormal = rowData?.numeric?.lowNormal;
	const hiNormal = rowData?.numeric?.hiNormal;
	const label = rowData?.numeric?.label;
	const obsValue = rowData?.obs?.value;
	let result = "";

	// if (isText && label) {
	// 	result = obsValue === label ? "" : "fw-bold";
	// } 

	if (validNumber(hiNormal) && obsValue !== null && obsValue > hiNormal) {
		result = "hiNormal";
	} 

	if (validNumber(lowNormal) && obsValue !== null && obsValue < lowNormal) {
		result = "lowNormal";
	}

	return result;
};
